import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatTimeWithoutSeconds(time: string): string {
  if (!time) return time;
  // Convert "HH:MM:SS" to "HH:MM"
  return time.split(':').slice(0, 2).join(':');
}

export function getOrdinalSuffix(num: number): string {
  // Handle special cases for 11th, 12th, 13th
  if (num >= 11 && num <= 13) {
    return `${num}th`;
  }
  
  // Handle other numbers based on last digit
  const lastDigit = num % 10;
  switch (lastDigit) {
    case 1:
      return `${num}st`;
    case 2:
      return `${num}nd`;
    case 3:
      return `${num}rd`;
    default:
      return `${num}th`;
  }
}
